import { computed, defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { Popover } from 'bootstrap';
import { useDateFormat } from '@/composables/dateFormat';
import { useStore } from 'vuex';
import { MementoAction, MementoGetter } from '@/store/memento/memento.module';
import { Memento } from '@/store/memento/memento.model';

export default defineComponent({
  name: 'MementoPage',
  setup: () => {
    const dateFormat = useDateFormat();
    const store = useStore();
    const mementos = computed<Memento[]>(() => store.getters[MementoGetter.ALL]);
    const popoverList = ref<Popover[]>([]);
    const datatable = ref<HTMLTableElement>();
    const dtInstance = ref();

    onMounted(() => {
      store.dispatch(MementoAction.FETCH)
        .then(() => {
          const popoverTriggerList = computed<HTMLElement[]>(() => [].slice.call(document.querySelectorAll('[data-bs-toggle="popover-project"]')) as HTMLElement[]);
          popoverList.value.map(element => element.hide());
          popoverList.value = popoverTriggerList.value?.map(element => new Popover(element, { trigger: 'hover', placement: 'right' }));

          initialDataTable();
        });
    });

    onUnmounted(() => {
      dtInstance.value?.destroy();
    });

    const initialDataTable = () => {
      const dt = datatable.value as HTMLTableElement;
        if (!$.fn.dataTable.isDataTable(dt)) {
        dtInstance.value = $(dt).DataTable({
          columnDefs: [
            { type: 'formatted-num', targets: 3 },
          ],
          language: {
            emptyTable: 'ไม่พบข้อมูล',
            info: 'แสดง _START_ ถึง _END_ จากจำนวนทั้งหมด _TOTAL_',
            infoEmpty: 'แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0',
            infoFiltered: '(ค้นหาจากจำนวนทั้งหมด _MAX_)',
            lengthMenu: 'แสดงข้อมูล _MENU_',
            paginate: {
              next: 'ถัดไป',
              previous: 'ก่อนหน้า',
              first: 'First',
              last: 'Last'
            },
            search: 'ค้นหา:',
            zeroRecords: 'ไม่พบข้อมูลที่ค้นหา',
          }
        });
        }
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDateTime(date, 'short');

    return {
      datatable,
      mementos,
      thaiDate,
    };
  }
});
